import React from 'react';
import {
  SkeletonLine,
  SkeletonCircle,
  Box,
  Layout,
  Cell,
} from '@wix/design-system';

export function SkeletonAppBox() {
  return (
    <Box
      width="280px"
      height="215px"
      minWidth="270px"
      padding="18px"
      boxSizing="border-box"
      border="1px solid #dfe5eb"
      borderRadius="8px"
    >
      <Layout rowHeight="55px">
        <Cell span={12}>
          <SkeletonCircle diameter="42px" />
          <SkeletonLine width="168px" marginTop="12px" />
        </Cell>
        <Box width="fit-content">
          <Cell>
            <SkeletonLine width="236px" marginBottom="6px" />
            <SkeletonLine width="117px" />
            <Box marginTop="50px" verticalAlign="space-between">
              <SkeletonLine width="80px" />
              <SkeletonLine width="60px" />
            </Box>
          </Cell>
        </Box>
      </Layout>
    </Box>
  );
}
